import * as R from 'ramda'
import { call, reducer } from '../../helpers/api/meta'
import { getLdap } from '../../helpers/api/api'

// Action types
export const GET_LDAP = 'GET_LDAP'

// API calls
export const callGetLdap = (inputs) => {
  const meta = {
    endpoint: (params) => getLdap(params),
    inputs,
    action: GET_LDAP,
    messages: {
      id: 'getLdap',
      success: 'LDAP user loaded',
      failure: 'Could not get LDAP user',
    }
  }
  return call(meta)
}

// Reducer
const initialState = {
  loading: false,
  data: {},
  error: {}
}
const saveLdap = (state, action) => {  
  return R.assoc('data', action, state)
}
const messages = {
  failure: 'Could not get LDAP user',
}
export default reducer(initialState, GET_LDAP, saveLdap, messages.failure)